import type { ReactElement } from 'react';

import { t } from '@/shared/i18n';

import { useMorningMode } from './shared';
import styles from './morningToggle.module.css';

/**
 * Тумблер «На утро» в шапке киоска (T-055, решение владельца 2026-10-08 — место
 * в шапке между «☰ Печать» и «☰ Ещё» указано на фото клиента).
 *
 * Нет разрешения точки — нет и тумблера: пустое место лучше выключенного переключателя,
 * о котором повар будет спрашивать. Что именно уйдёт на этикетку, называет кнопка
 * печати («Печать на утро», «завтра 08:00»), а не тумблер — смотрят на неё перед тапом.
 */
export function MorningToggle(): ReactElement | null {
  const mode = useMorningMode();
  if (!mode.available) return null;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={mode.on}
      className={styles.toggle}
      onClick={mode.toggle}
      data-testid="morning-toggle"
    >
      <span className={styles.track} data-on={mode.on ? '' : undefined} aria-hidden="true">
        <span className={styles.thumb} />
      </span>
      <span className={styles.label}>{t('print.morning.toggle')}</span>
    </button>
  );
}
